import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

export type WebGlContextStatus = "initializing" | "ready" | "lost" | "restored";

interface ContextLifecycleProps {
  onStatusChange: (status: WebGlContextStatus) => void;
}

export function ContextLifecycle({ onStatusChange }: ContextLifecycleProps) {
  const canvas = useThree((state) => state.gl.domElement);

  useEffect(() => {
    const onLost = (event: Event) => {
      event.preventDefault();
      onStatusChange("lost");
    };
    const onRestored = () => onStatusChange("restored");

    canvas.addEventListener("webglcontextlost", onLost);
    canvas.addEventListener("webglcontextrestored", onRestored);
    onStatusChange("ready");

    return () => {
      canvas.removeEventListener("webglcontextlost", onLost);
      canvas.removeEventListener("webglcontextrestored", onRestored);
    };
  }, [canvas, onStatusChange]);

  return null;
}
